import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id C19DAE9D-F5EE-4968-99AD-7F1C55B6ACB4
 * name screw-machine-round-top
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/screw-machine-round-top.svg
 * tags
 * - Hardware / Tools 
 */
export const ScrewMachineRoundTopIcon = createSvgIcon(<><path d="M14.5,7.3L13.5,8V7H10.5V10L9.5,10.7V11.7L14.5,8.4V7.3M14.5,11.3L13.5,12V10L10.5,12V14L9.5,14.7V15.7L14.5,12.4V11.3M14.5,15.3L13.5,16V14L10.5,16V18L9.5,18.7V19.7L14.5,16.4V15.3M7,6H17C17,6 16,3 12,3C8,3 7,6 7,6M13.5,18V21H10.5V20L13.5,18Z" /></>, 'ScrewMachineRoundTopIcon');
export default ScrewMachineRoundTopIcon